<script>
import InlineSvg from 'vue-inline-svg'

export default {
  components: {
    InlineSvg,
  },
  props: {
    isFavorite: {
      type: Boolean,
    },
    options: {
      type: Object,
      default: () => ({
        width: null,
        height: null,
      }),
    },
  },
  data() {
    return {
      isPendingUnfavorite: false,
    }
  },

  computed: {
    heartIconPath() {
      return this.isFavorite ? require('@assets/icons/HeartFull.svg') : require('@assets/icons/HeartEmpty.svg')
    },
    trashIconPath() {
      return require('@assets/icons/Trash.svg')
    },
    heartDimensions() {
      return {
        width: this.options?.width,
        height: this.options?.height,
      }
    },
  },
  methods: {
    handleHeartClick() {
      if (this.isFavorite && !this.isPendingUnfavorite) {
        this.isPendingUnfavorite = true
        setTimeout(() => {
          this.isPendingUnfavorite = false
        }, 3000)
        return
      }

      this.$emit('handleHeartClick')
    },
  },
}
</script>

<template>
  <InlineSvg
    v-if="isPendingUnfavorite"
    :class="$style.trash"
    :width="heartDimensions.width"
    :height="heartDimensions.height"
    :src="trashIconPath"
    @click.stop="handleHeartClick"
    v-on="$listeners" />
  <InlineSvg
    v-else
    :class="$style.heart"
    :width="heartDimensions.width"
    :height="heartDimensions.height"
    :src="heartIconPath"
    @click.stop="handleHeartClick"
    v-on="$listeners" />
</template>

<style lang="scss" module>
@import '@design';

.heart {
  font-size: 50px;
  color: $light-gray;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
}

.trash {
  font-size: 50px;
  cursor: pointer;
  filter: brightness(0) saturate(100%) invert(86%) sepia(10%) saturate(59%) hue-rotate(177deg) brightness(102%)
    contrast(86%);
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.1);
  }
}
</style>
